export default __webpack_public_path__ + "media/images/cta_blocks/gift_list-89622995242eca4bf38f981a35bbb8c8.jpg";